import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { formatErrorCode } from '../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { DefaultLookupResponse } from '../../models/core-apis/default-lookup.interfaces';
import { DefaultLookupService } from '../../services/default-lookup.service';
import * as fromDefaultLookupActions from '../actions/default-lookup.actions';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';
import {
  getCacheKeySuffix,
  shouldTriggerDefaultLookupApi
} from '../selectors/default-lookup.selectors';

@Injectable({ providedIn: 'root' })
export class DefaultLookupEffects {
  loadDefaultLookupLanding$ = createEffect(
    (): Observable<Action> =>
      this.DefaultLookupActions$.pipe(
        ofType(fromDefaultLookupActions.LoadDefaultLookupLanding),
        concatLatestFrom(() => [
          this.store.select(getCacheKeySuffix),
          this.store.select(shouldTriggerDefaultLookupApi)
        ]),
        filter(
          ([, , shouldTriggerDefaultLookupApiValue]) =>
            shouldTriggerDefaultLookupApiValue
        ),
        switchMap(([, cacheKeySuffix]) =>
          this.service.getDefaultLookupApi(cacheKeySuffix).pipe(
            map((defaultLookupResponse: DefaultLookupResponse) =>
              fromDefaultLookupActions.LoadDefaultLookupLandingSuccess({
                defaultLookupLandingData: defaultLookupResponse
              })
            ),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.DEFAULT_LOOKUP_FAILURE,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.DEFAULT_LOOKUP_FAILURE
                }),
                fromDefaultLookupActions.LoadDefaultLookupLandingFailure()
              );
            })
          )
        )
      )
  );

  constructor(
    private DefaultLookupActions$: Actions,
    private service: DefaultLookupService,
    private store: Store
  ) {}
}
